import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const AttendanceSettingsPage = lazy(() => import("@/pages/AttendanceSetting/AttendanceSettingsPage"));
const AttendanceSetting = lazy(() => import("@/pages/AttendanceSetting/AttendanceSetting"));
const TimeSheetApprover = lazy(() => import("@/pages/AttendanceSetting/Time-Sheet approver/TimeSheetApprover"));
 
const AttendanceSettingRoute: RouteConfig = {
  path : "",
  pageName: "Attendance Setting",
  element: <AttendanceSettingsPage />,
  permission: ["AttendanceSettings"],
  children : {
    ATTENDANCE_SETTINGS : {
      path: "attendance-setting",
      element: <AttendanceSetting />,
      pageName: "Attendance Setting",
      sidebar: { show: true, icon: "" },      
    },
    TIME_SHEET_APPROVER : {
      path : "timesheetapprover",
      element : <TimeSheetApprover/>,
      pageName : "Timesheet Approver",
      sidebar: { show: true, icon: "" },      
    }
  }
};

export default AttendanceSettingRoute;
